(function() {
	'use strict';

	$.validator.addMethod('no-digits', function(value) {
		// Let 'pattern' be a pattern that matches a digit.
		var pattern = /\d/;
		// Check if the value in the form control does not match 'pattern'.
		return !pattern.test(value);
	}, 'Please do no enter any digits');
}());
